<template>
  <div id="app">
    <!-- <high-loading :options='options'></high-loading> -->
    <div @click='handleLogin'>点我！！！！</div>
  </div>
</template>

<script>
  export default {
    name: 'app',
    data() {
      return {
      }
    },
    methods: {
      handleLogin() {
        var self = this;
        this.$hiloading.show(); // loading显示 --- 回调开始  Loading 显示
        // let timer = setTimeout(function () {
        //   self.$hiloading.hide()
        // }, 3000000000)
      }
    }
  }
</script>

<style lang="scss">
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
  }

  h1,
  h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }
</style>


// WEBPACK FOOTER //
// src/App.vue